<template>
  <form class="lf-form">
    <div class="row">
      <div class="col-lg-8">
        <h4 class="ml-3 mt-3">{{$t('small_technical_grants.logical_framework__section_title')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="logical.projectTitle"
            disabled
            v-model="GrantForm.title"
            :error="getError('logical.projectTitle')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.logical__1_project_title')"
            :label="$t('medium_grant.logical__1_project_title')"
            :placeholder="$t('medium_grant.logical__1_project_title')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.organisation"
            v-model="GrantForm.model.technical.leadApplicantName"
            :error="getError('technical.leadApplicantName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.logical__1_organisation')"
            :label="$t('medium_grant.logical__1_organisation')"
            :placeholder="$t('medium_grant.logical__1_organisation')"
          >
          </textarea>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 0; margin-right: 0">
      <div class="col-lg-6">
        <h4 class="card-title">{{$t('small_technical_grants.logical_framework__action_component_objectives_card_title')}}</h4>
        <h6>{{$t('small_technical_grants.logical_framework__action_component_objectives_instructions')}}</h6>
        <div class="form-group">
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.enhanceManagement">
            {{$t('small_technical_grants.logical_framework__action_component_objectives_checkbox_1')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.enforceLegalFramework">
            {{$t('small_technical_grants.logical_framework__action_component_objectives_checkbox_2')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.supportLocalCommunities">
            {{$t('small_technical_grants.logical_framework__action_component_objectives_checkbox_3')}}
          </base-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <table class="mt-5 mb-2 table-bordered" width="100%">
          <thead class="text-center">
            <tr>
              <th class="align-baseline">{{$t('small_technical_grants.logical_framework__priorities_for_actions_title')}}</th>
              <th class="align-baseline" style="border: none"></th>
              <th class="align-baseline" style="border: none"></th>
              <th class="align-baseline" style="border: none"></th>
            </tr>
            <tr>
              <th class="align-baseline" width="25%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_results')}}
              </th>
              <th class="align-baseline" width="20%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_indicators')}}
              </th>
              <th class="align-baseline" width="15%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_targets')}}
              </th>
              <th class="align-baseline" width="15%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_source')}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-baseline">{{$t('small_technical_grants.logical_framework__priorities_for_actions_instructions_results')}}</td>
              <td class="align-baseline">{{$t('small_technical_grants.logical_framework__priorities_for_actions_instructions_indicators')}}</td>
              <td class="align-baseline"></td>
              <td class="align-baseline">{{$t('small_technical_grants.logical_framework__priorities_for_actions_instructions_source')}}</td>
            </tr>
            <tr v-for="(item, index) in GrantForm.model.technical.priorityResources" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_results')"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_indicators')"
                  v-model="item.indicator"
                >
                </textarea>
              </td>
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_targets')"
                  v-model="item.target"
                >
                </textarea>
              </td>
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_source')"
                  v-model="item.source"
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addPriorityResource"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>

        <table class="mt-5 mb-2 table-bordered" width="100%">
          <thead class="text-center">
            <tr>
              <th class="align-baseline">{{$t('small_technical_grants.logical_framework__monitoring_resources_title')}}</th>
              <th class="align-baseline" style="border: none"></th>
              <th class="align-baseline" style="border: none"></th>
              <th class="align-baseline" style="border: none"></th>
            </tr>
            <tr>
              <th class="align-baseline" width="25%">
                {{$t('small_technical_grants.logical_framework__monitoring_resources_header_results')}}
              </th>
              <th class="align-baseline" width="20%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_indicators')}}
              </th>
              <th class="align-baseline" width="15%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_targets')}}
              </th>
              <th class="align-baseline" width="15%">
                {{$t('small_technical_grants.logical_framework__priorities_for_actions_header_source')}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.model.technical.monitoringResources" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__monitoring_resources_placeholder_results')"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_indicators')"
                  v-model="item.indicator"
                >
                </textarea>
              </td>
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_targets')"
                  v-model="item.target"
                >
                </textarea>
              </td>
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.logical_framework__priorities_for_actions_placeholder_source')"
                  v-model="item.source"
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <base-button
          type="primary"
          @click.native="addMonitoringResource"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>

        <table class="mt-5 table-bordered" width="100%">
          <tbody>
            <tr>
              <td style="padding: 40px">
                <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_ecpcm_guidelines')}}</span>
                <br/>
                <a class="text-body" href="https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf" target="_blank">https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addPriorityResource() {
        if (!GrantForm.model.technical.priorityResources)
        {
          GrantForm.model.technical.priorityResources = [];
        }

        GrantForm.model.technical.priorityResources.push({
          result: '',
          indicator: '',
          target: '',
          source: ''
        });
        this.$forceUpdate();
      },
      addMonitoringResource() {
        if (!GrantForm.model.technical.monitoringResources)
        {
          GrantForm.model.technical.monitoringResources = [];
        }

        GrantForm.model.technical.monitoringResources.push({
          result: '',
          indicator: '',
          target: '',
          source: ''
        });
        this.$forceUpdate();
      }
    }
  }
</script>
<style lang="scss" scoped>
.table-bordered td,
.table-bordered th
{
  padding: 20px;
}

.lf-form
{
  border: 1px solid #000;
}
</style>
